import { useSingleton } from './useSingleton';
import { useWillUnmount } from './useWillUnmount';
export function useSafeInit(creator) {
  var unbind = useSingleton(creator);
  useWillUnmount(unbind);
}